export default __webpack_public_path__ + "static/media/close.aff74f19.svg";